import { create } from 'zustand';
import { Summary, Event } from '../../interfaces/sports';
import { deepCopy } from '../../common/objectUtils';
import { devTools } from '../../common/devtools';

export type EventNumberMap = Map<number, { eventId: number }>;

export interface EventStoreState {
  events?: Event[];
  summary?: Summary;
  eventNumberMap?: EventNumberMap;
  inPlay: boolean;
  setStore: ({ events, summary }: { events?: Event[]; summary?: Summary }) => void;
  setEventNumberMap: (eventNumberMap: EventNumberMap) => void;
  setEventFinished: (eventNumber: number) => void;
}

export const useEventStore = create<EventStoreState>()((set) => ({
  events: undefined,
  summary: undefined,
  eventNumberMap: undefined,
  inPlay: false,
  setStore: ({ events, summary }) =>
    set(() => {
      if (events?.length === 0) {
        events = undefined;
        summary = undefined;
      }
      // we can use the summary to see how many events are in play
      // if at least one is in play then we know this predictor is in play
      return { events, summary, inPlay: getInPlay(summary) };
    }),
  setEventNumberMap: (eventNumberMap) => set(() => ({ eventNumberMap })),
  setEventFinished: (eventNumber) =>
    set((state) => {
      const events = deepCopy(state.events);
      const id = state.eventNumberMap?.get(eventNumber)?.eventId;
      const event = events?.find((event) => event.eventId === id);
      devTools.log('setEventFinished event:', event);
      if (!event) return { ...state };
      event.eventFinished = true;
      return { events };
    }),
}));

const getInPlay = (summary?: Summary) => {
  if (!summary) return false;
  if (summary.minEventStartTime < Date.now()) return true;
  return summary.inPlayEvents + summary.fullTimeEvents > 0;
};
